import { render, staticRenderFns } from "./CopyableInput.vue?vue&type=template&id=125e22e2"
import script from "./CopyableInput.vue?vue&type=script&lang=js"
export * from "./CopyableInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports